import gql from "graphql-tag";
import CompanyIssuerFields from "lib/graphql/fragments/CompanyIssuerFields";

export default gql`
  query SearchIssuersByTickerSymbol($tickerSymbol: TickerSymbol!, $vertical: PlatformVertical) {
    searchIssuersByTickerSymbol(tickerSymbol: $tickerSymbol, vertical: $vertical) {
      _id
      ...CompanyIssuerFields
    }
  }
  ${CompanyIssuerFields}
`;
